import {
  PreferenceGroupSubTypeEnum,
  PreferenceTagItemModel,
  getPreferenceGroupPreferenceKey,
  getPreferenceGroupsKey,
  useGetPreferenceGroup,
  useGetPreferenceGroups,
} from 'api-hooks/preference-tag';
import { PreferenceGroupTypeEnum } from 'common/constants/enum';
import { ModelTransformer } from 'common/helpers/common';

import { ColumnDataType } from '../type';

export function preferenceTransformer(item: PreferenceTagItemModel) {
  return {
    id: item.id,
    label: item.name,
  };
}

const preferenceColumn = ({
  type = PreferenceGroupTypeEnum.Booking,
  subType,
}: {
  type?: PreferenceGroupTypeEnum;
  subType: PreferenceGroupSubTypeEnum;
}) => {
  return {
    dataType: ColumnDataType.select,
    useListQueryHook: useGetPreferenceGroups,
    useDetailLazyQueryHook: useGetPreferenceGroup,
    listKeyFunction: getPreferenceGroupsKey,
    detailKeyFunction: getPreferenceGroupPreferenceKey,
    getMemoizedListVariables: (page, q) => ({
      params: {
        q,
        page,
        type,
        sub_type: subType,
      },
    }),
    getMemoizedDetailVariables: (value: string) => ({
      id: value,
    }),
    listTransformer: (result) => {
      return result.data.map((v) => {
        const data = ModelTransformer(v, PreferenceTagItemModel);
        return preferenceTransformer(data);
      });
    },
    detailTransformer: (result) => {
      const data = ModelTransformer(result.data, PreferenceTagItemModel);
      return preferenceTransformer(data);
    },
    paginationTransformer: (result) => {
      return result.meta;
    },
  };
};

export default preferenceColumn;
